import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { HistoricoFuncionarioService } from '../../../../folha-pagamento/src/historico-funcionario/historico-funcionario.service';
import { HistoricoFuncionarioDetailDTO } from '../../../../folha-pagamento/src/historico-funcionario/historico-funcionario-detail-dto';

@Injectable()
export class PortalHistoricoFuncionarioService extends HistoricoFuncionarioService {

  private readonly resourcePortal: string = '/api/portal-servidor/historico-funcionario';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public findHistoricoFuncionarioByFichaFinanceiraId(fichaFinanceiraId: string): Observable<HistoricoFuncionarioDetailDTO> {
    if (!fichaFinanceiraId) {
      return of();
    }

    return this.httpClient.get({
      resource: `${this.resourcePortal}?fichaFinanceiraId=${fichaFinanceiraId}`
    });
  }

  public findByCompetenciaAndFuncionarioId(funcionarioId: number): Observable<HistoricoFuncionarioDetailDTO> {
    if (!funcionarioId) {
      return of();
    }

    return this.httpClient.get({
      resource: `${this.resourcePortal}/by-competencia-funcionario?funcionarioId=${funcionarioId}`,
      disableSpinner: true
    });
  }
}
